// Loads the YouTube IFrame API once and resolves with window.YT
// https://developers.google.com/youtube/iframe_api_reference

let apiPromise = null;

const loadApiScript = () =>
  new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = () => resolve(window.YT);
    const script = document.createElement("script");
    script.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(script);
  });

export const fetchYouTubeApi = () => {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  apiPromise ??= loadApiScript();
  return apiPromise;
};
